/**
 * Clears persisted UI view state from sessionStorage (dashboard, inbox, etc.).
 * Called on logout so the next user does not inherit filters/tabs.
 */
export function clearPersistedViewStateStorage() {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  const prefixes = ['hr.viewState.v1:', 'hr.inboxAdminState.v1:'];
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && prefixes.some((prefix) => key.startsWith(prefix))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // ignore private mode / quota
  }
}
